import { useTheme } from '../context/ThemeContext';
import { useSiteLogo } from '../lib/useSiteLogo';

export const Footer = () => {
  const year = new Date().getFullYear();
  const { theme } = useTheme();
  const logo = useSiteLogo(theme);

  return (
    <footer className="py-8 bg-background border-t border-border" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Logo */}
          <div className="flex items-center gap-3 min-h-[54px]">
            <img src={logo} alt="AgrosJet" width="106" height="54" loading="lazy" decoding="async" className="h-[54px] w-auto object-contain" />
          </div>

          {/* Copyright */}
          <p className="text-sm text-foreground/40">
            © {year} AgrosJet. Tüm hakları saklıdır.
          </p>
          <p className="text-sm text-foreground/40 mt-1">
            Created by{' '}
            <a 
              href="https://agrostech.net" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-brand-accent hover:underline"
            >
              AgrosTech
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};
